import { Box, ButtonBase, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router";

import { layoutTokens as layout, semanticColors as colors, textStyles } from "@/designTokens";
import { ViewKeys } from "@/hooks/usePropertyViews";
import theme from "@/theme";

import { ThinArrowIcon } from "../icon/ThinArrowIcon";

import { DetailLink } from "./DetailSection";

const useStyles = makeStyles({
  root: {
    display: "grid",
    gap: layout.space[12],
    padding: layout.space[24],
    [theme.breakpoints.up("md")]: { padding: 0 },
  },
  edit: {
    minHeight: 44,
    justifyContent: "space-between",
    color: colors["action/primary"],
    ...textStyles["SP/Button/M"],
  },
  arrow: { width: 16, height: 16 },
});

export const DetailNavigation: React.FC<{
  onChange: (view: ViewKeys) => void;
  selectedView: ViewKeys;
  building?: boolean;
  onShowDetail?: () => void;
}> = ({ onChange, selectedView, building, onShowDetail }) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Box className={classes.root}>
      {!onShowDetail && (
        <ButtonBase
          id="management-tour-menu"
          className={classes.edit}
          onClick={() => history.push("/management/detail/settings")}
        >
          <Typography>経費情報などを編集</Typography>
          <ThinArrowIcon className={classes.arrow} />
        </ButtonBase>
      )}
      {selectedView !== "operation" && <DetailLink title="収支に戻る" onClick={() => onChange("operation")} />}
      <DetailLink title="物件情報" description="基本情報・購入時情報など" onClick={() => onChange("property")} />
      <DetailLink
        title="物件書類"
        description="売買契約書・ローン契約書など"
        onClick={() => history.push("/property_document_list")}
      />
      {!building && (
        <>
          <DetailLink
            title="シミュレーション"
            description="将来の資産価値・収支予測"
            onClick={() => onChange("simulation")}
          />
          <DetailLink
            id="management-tour-nearby"
            title="周辺の成約事例"
            description="近隣の類似物件の売買価格"
            onClick={() => onChange("nearby")}
          />
        </>
      )}
      {onShowDetail && (
        <DetailLink
          id="management-tour-menu"
          title="編集する"
          description="詳細表示に切り替えて編集します"
          onClick={onShowDetail}
        />
      )}
    </Box>
  );
};
